<template>
    <div>
        <component :is="currentComponent" @goToComponent="handleComponentChange" :after_id="componentParams.after_id"
            :partner_id="componentParams.partner_id">
        </component>
    </div>
</template>
<script>
import AfterOrderList from './afterOrder/AfterOrderList.vue'
import AfterOrderDetail from './afterOrder/AfterOrderDetail.vue'

export default {
    name: 'AfterSalesOrders',
    components: {
        AfterOrderList,
        AfterOrderDetail
    },
    data() {
        return {
            currentComponent: 'AfterOrderList', // 默认显示订单列表
            componentParams: {
                after_id: '',
                partner_id: ''
            }
        }
    },
    mounted() {
        // 组件挂载时默认显示订单列表
        this.currentComponent = 'AfterOrderList';
    },
    methods: {
        // 处理组件切换
        handleComponentChange(componentName, params) {
            if (params) {
                // 如果切换到列表组件，重置after_id
                if (componentName === 'AfterOrderList') {
                    this.componentParams = { 
                        ...this.componentParams, 
                        ...params,
                        after_id: '' // 重置after_id
                    };
                } else {
                    this.componentParams = { ...this.componentParams, ...params };
                }
            }
            this.currentComponent = componentName;
        }
    }
}
</script>

<style scoped>
/* 可以根据需要添加样式 */
</style>